import styled, { css } from 'styled-components';

export const HostGatorConfigModalWrapper = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 16px 8px 16px 8px;
  `}
`;

export const TitleWrapper = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v1.color.text.primary};
    font-family: ${theme.v1.font.family.primary};
    font-size: ${theme.font.sizes.xxl};
    font-weight: ${theme.v1.font.weights.bold};
    line-height: ${theme.font.lineHeights.xxxxxl};
    margin: 0;
    max-width: 90%;
  `}
`;

export const SubTitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v1.color.text.primary};
    font-family: ${theme.v1.font.family.primary};
    font-size: ${theme.font.sizes.sm};
    line-height: ${theme.font.lineHeights.lg};
    font-weight: ${theme.v1.font.weights.medium};
    margin: 0;

    > div {
      display: inline;
      margin-left: 3px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    align-self: center;
    margin-top: 16px;
    display: block;
    text-align: center;
    @media (min-width: ${theme.v1.breakpoints.md}) {
      display: flex;
      align-items: center;
    }
  `}
`;

export const CheckboxWrapper = styled.div`
  ${({ theme }) => css`
      display: flex;
      align-items: flex-start;
      align-self: center;
      gap: 8px;
      color: ${theme.v1.color.text.primary};
      font-family: ${theme.v1.font.family.primary};
      font-size: ${theme.font.sizes.xxs};
      line-height: ${theme.font.lineHeights.md};
      font-weight: ${theme.v1.font.weights.medium};

      > input {
        cursor: pointer;
        margin: 0;
        width: 41px;
        height: 24px;
        accent-color: ${theme.v1.color.action.hover};
      }

      @media (min-width: ${theme.v1.breakpoints.sm}) {
        align-items: center;

        > input {
          margin: 0;
          width: 24px;
          height: 24px;
        }
      }
  `}
`;

export const MessageWrapper = styled.div`
  ${({ theme }) => css`
      display: flex;
      align-items: flex-start;
      gap: 8px;
      margin-top: 16px;
      color: ${theme.v1.color.text.primary};
      font-family: ${theme.v1.font.family.primary};
      font-size: ${theme.font.sizes.xxs};
      line-height: ${theme.font.lineHeights.md};
      font-weight: ${theme.v1.font.weights.medium};

      > p {
        margin: 0;
      }
  `}
`;

export const ButtonConfig = styled.button`
  ${({ theme }) => css`
    color: ${theme.palette.secondary.primary};
    font-family: ${theme.font.family.secondary};
    font-size: ${theme.font.sizes.md};
    line-height: ${theme.font.lineHeights.lg};
    font-weight: ${theme.font.weights.medium};
    cursor: pointer;
    border: 0;
    padding: 0;
    margin: 0 16px 24px 16px;
    background: transparent;
    &:disabled {
      opacity: 0.5;
    }
    &:first-child{
      display: none;
    }
    &:last-child{
      margin-top: 24px;
      margin-bottom: 0;
    }
    @media (min-width: ${theme.v1.breakpoints.sm}) {
      margin: 0 8px 0 0;
      &:first-child{
        margin-top: 0;
        display: flex;
      }
      &:last-child{
        display: none;
      }
    }
  `}
`;
